<script>
import apiConfig from '../../config/api.config.js'
import {DateUtil} from '@/utils/date.js'
import qlEditor from 'vue-quill-editor'
import showMap from '@/components/showMapWindowMask'
import mapDropPin from '../assets/map_icon/map_drop_pin.png'
import dialog from '@/components/Dialog'
export default {
  components: {qlEditor, showMap, 'v-dialog': dialog},
  props: {
    backName: {type: String, default: ''},
    rightTopBtnName: {type: String, default: ''},
    shiftStatus: {type: Number, default: 3}, // 1 运行前 2 运行中 3 运行完
    mapBtnVisibility: {type: Boolean, default: true} // fasle:不显示地图按钮 true:显示按钮(默认)
  },
  data () {
    return {
      routeName: '',
      shiftMovementFlag: false,
      showDialog: false,
      eventId: '',
      shiftInfo1: {},
      eventInfo: {},
      shiftId: '',
      eventDate: '',
      shiftPasspoints1: [],
      // 地图标记点List
      pointDataList: [],
      shiftInfo: {
        title: '',
        shiftReservationInfos: [],
        shiftPasspoints: [
          {
            startEstimateTime: '',
            stationName: '',
            address: '',
            arriveActualTime: ''
          }
        ]
      },
      shiftReservation: {
        flag: 'add'
      },
      shiftPasspoints: [],
      rightToBtn: true,
      // 出力Dialog
      showPrintDialog: false,
      dialogPrintOption: {
        showNo: true,
        text: 'データをダウンロードします。<br/>よろしいですか？',
        cancelButtonText: 'キャンセル',
        confirmButtonText: '実行'
      }
    }
  },
  created () {
    // 从一览画面传过来的shiftId
    let shiftId = this.$route.query.shiftId
    let flag = this.$route.query.flag
    if (flag) {
      this.shiftMovementFlag = this.$route.query.flag
    }

    // 从运行状况一览画面的详细按钮进来，对取到便的信息经行预处理
    // 便の详细（运行完）不需要icon和地图
    if (sessionStorage.getItem('shiftDetail') === null
      || sessionStorage.getItem('fromEditMovementWork') === 'fromEditMovementWork') {

      console.log("APIから便情報取得")
      console.log(sessionStorage.getItem('shiftId'))
      if(shiftId == null  && sessionStorage.getItem('shiftId') != null){
        shiftId = sessionStorage.getItem('shiftId')
        this.shiftId = sessionStorage.getItem('shiftId')
      }
      this.$emit('transShiftID', shiftId)
      sessionStorage.removeItem('fromEditMovementWork')
      sessionStorage.removeItem('shiftId')
      this.$axios.get('shift/queryShiftInfoDetail', {params: {shiftId: shiftId}})
        .then(response => {
          this.shiftInfo = response.data.shiftInfo
          this.shiftInfo.moveShiftTime = DateUtil.yearWeek(this.shiftInfo.moveShiftTime)
          this.shiftInfo1 = this.shiftInfo
          let eventId = this.shiftInfo.eventId
          this.eventId = eventId
          this.shiftId = this.shiftInfo.shiftId
          let shiftPasspoints = this.shiftInfo.shiftPasspoints
          let sps = []
          if (shiftPasspoints.length !== 0) {
            let stopObj = this.isStop(shiftPasspoints[0].stationId)
            let startPassengers = stopObj.startPassengers
            let arrivePassengers = stopObj.arrivePassengers
            let startPointPassengers = stopObj.startPassengers
            let arrivePointPassengers = stopObj.arrivePassengers
            let showPassengers = false
            if (startPassengers.length > 0) {
              showPassengers = true
            }
            // 添加起始S
            sps.push(
              {
                listIndex: 'S',
                index: 'S',
                estimateTime: shiftPasspoints[0].startEstimateTime !== null ? shiftPasspoints[0].startEstimateTime : this.shiftInfo.startEstimateTimeSlot,
                name: shiftPasspoints[0].stationName,
                address: shiftPasspoints[0].address,
                actualTime: shiftPasspoints[0].arriveActualTime,
                stopFlag: true,
                displayFlag: shiftPasspoints[0].displayFlag,
                routeType: shiftPasspoints[0].routeType,
                stationId: shiftPasspoints[0].stationId,
                stationLat: shiftPasspoints[0].stationLat,
                stationLng: shiftPasspoints[0].stationLng,
                passengerNameKana: '',
                reserveId: '',
                startPassengers: startPassengers,
                arrivePassengers: arrivePassengers,
                showPassengers: showPassengers,
                stationNote: shiftPasspoints[0].stationNote,
                // 该点所有上车人
                startPointPassengers: startPointPassengers,
                // 该点所有下车人
                arrivePointPassengers: arrivePointPassengers
              }
            )
            // 一般情况
            let listIndex = -1
            let houselistIndex = 0
            let houseIndex = 0
            let gIndex = 0
            for (let shiftPasspoint of shiftPasspoints) {
              listIndex++
              if (listIndex === 0) continue
              let splistIndex = ''
              let spIndex = ''
              if (listIndex === shiftPasspoints.length - 1) {
                spIndex = splistIndex = 'G'
              } else if (shiftPasspoint.routeType === '0') {
                spIndex = 'G' + (++gIndex)
              } else {
                spIndex = '' + (++houseIndex)
              }
              let name = ''
              let nameKana = ''
              let addressObj = null
              let stopFlag = false
              // 停留所的上下车人
              let startPassengers = []
              let arrivePassengers = []
              // 上下车人
              let startPointPassengers = []
              let arrivePointPassengers = []
              if (shiftPasspoint.routeType === '1') {
                let nameObj = this.getPassengerNameObj(shiftPasspoint.reserveId)
                name = nameObj.name
                nameKana = nameObj.nameKana
                addressObj = this.getPassengerAddressObj(shiftPasspoint.reserveId)
                stopFlag = true
                if (this.shiftInfo.shiftFlag === 0) {
                  startPointPassengers.push({reserveId: shiftPasspoint.reserveId, name: name})
                } else {
                  arrivePointPassengers.push({reserveId: shiftPasspoint.reserveId, name: name})
                }
              } else {
                name = shiftPasspoint.stationName
                addressObj = {address: shiftPasspoint.address, stationId: shiftPasspoint.stationId, lat: shiftPasspoint.stationLat, lng: shiftPasspoint.stationLng}
                let stopObj = this.isStop(shiftPasspoint.stationId)
                stopFlag = stopObj.stopFlag
                startPassengers = stopObj.startPassengers
                arrivePassengers = stopObj.arrivePassengers
                startPointPassengers = stopObj.startPassengers
                arrivePointPassengers = stopObj.arrivePassengers
              }
              if (listIndex === shiftPasspoints.length - 1) {
                stopFlag = true
              }
              if (!splistIndex && stopFlag) {
                splistIndex = '' + (++houselistIndex)
              }
              let showPassengers = false
              if (shiftPasspoint.routeType === '0' && stopFlag && startPassengers.length > 0) {
                showPassengers = true
              }
              sps.push(
                {
                  listIndex: splistIndex,
                  index: spIndex,
                  estimateTime: shiftPasspoint.arriveEstimateTime !== null ? shiftPasspoint.arriveEstimateTime : this.shiftInfo.arriveEstimateTimeSlot,
                  name: name,
                  address: addressObj.address,
                  actualTime: shiftPasspoint.arriveActualTime,
                  stopFlag: stopFlag,
                  displayFlag: shiftPasspoint.displayFlag,
                  routeType: shiftPasspoint.routeType,
                  stationId: addressObj.stationId,
                  stationLat: addressObj.lat,
                  stationLng: addressObj.lng,
                  passengerNameKana: nameKana,
                  reserveId: shiftPasspoint.reserveId,
                  startPassengers: startPassengers,
                  arrivePassengers: arrivePassengers,
                  showPassengers: showPassengers,
                  stationNote: shiftPasspoint.stationNote,
                  startPointPassengers: startPointPassengers,
                  arrivePointPassengers: arrivePointPassengers
                }
              )
            }
          }
          this.shiftPasspoints = sps
          this.shiftPasspoints1 = this.shiftPasspoints
          // 过滤掉没有到达的经由地
          // this.shiftPasspoints1 = this.shiftPasspoints.filter(i => {
          //   if (i.actualTime) {
          //     return i
          //   }
          // })
          sessionStorage.setItem('shiftDetail', JSON.stringify({shiftInfo: this.shiftInfo, shiftPasspoints: this.shiftPasspoints}))
          if (eventId !== null && eventId.length !== 0) {
            this.$axios.get('shift/queryShiftEventInfoDetail', {params: {eventId: eventId}})
              .then(response => {
                this.eventInfo = response.data.eventInfo
                this.eventDate = DateUtil.yearWeek(response.data.eventInfo.eventDate)
                sessionStorage.setItem('shiftEventInfo', JSON.stringify({eventInfo: this.eventInfo}))
              })
              .catch(function (error) {
                console.log(error)
              })
          }
        })
        .catch(error => {
          console.log(error)
        })
    } else {
      console.log("sessionから便情報取得")
      let shiftDetail = JSON.parse(sessionStorage.getItem('shiftDetail'))
      this.shiftInfo1 = shiftDetail.shiftInfo
      this.shiftPasspoints1 = shiftDetail.shiftPasspoints
      console.log(this.shiftPasspoints1)
      // 过滤掉没有到达的经由地
      // this.shiftPasspoints1 = shiftDetail.shiftPasspoints.filter(i => {
      //   if (i.actualTime) {
      //     return i
      //   }
      // })
      let eventId = shiftDetail.shiftInfo.eventId
      let routeId = shiftDetail.shiftInfo.routeId
      this.eventId = eventId
      this.shiftId = shiftDetail.shiftInfo.shiftId
      if (eventId !== null && eventId !== '') {
        this.$axios.get('shift/queryShiftEventInfoDetail', {params: {eventId: eventId}})
          .then(response => {
            this.eventInfo = response.data.eventInfo
            this.eventDate = DateUtil.yearWeek(response.data.eventInfo.eventDate)
            sessionStorage.setItem('shiftEventInfo', JSON.stringify({eventInfo: this.eventInfo}))
          })
          .catch(function (error) {
            console.log(error)
          })
      }
      // 运行状况不需要如route的信息
      if (this.shiftMovementFlag === false) {
        if (routeId !== null && eventId !== '') {
          this.$axios.get('shift/queryRouteNameById', {params: {routeId: routeId}})
            .then(response => {
              this.routeName = response.data.routeName
              // 描画を更新
              this.shiftInfo1.shiftPasspoints.splice(0,this.shiftInfo1.shiftPasspoints)
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      }
    }
    console.log(this.shiftInfo1)
  },
  methods: {
    stopWhere (array, index) {
      var afterIndexNoStop = false
      for (var i = index; i < array.length - 1; i++) {
        if (array[i + 1].actualTime !== null) {
          afterIndexNoStop = true
        }
      }
      return afterIndexNoStop
    },
    goPrintRunningTable () {
      this.dialogPrintOption.text = 'データをダウンロードします。<br/>よろしいですか？'
      this.dialogPrintOption.showNo = true
      this.dialogPrintOption.cancelButtonText = 'キャンセル'
      this.dialogPrintOption.confirmButtonText = '実行'

      this.showPrintDialog = true
      this.$refs.printDialog.confirm().then(() => {
        this.showPrintDialog = false
        this.exportRunningTable()
      })
        .catch(() => {
          this.showPrintDialog = false
        })
    },
    // 运行表出力
    exportRunningTable () {
      let baseUrl = apiConfig.baseUrl
      var elemIF = document.createElement('iframe')
      elemIF.src = baseUrl + 'shift/exportRunningTable?shiftId=' + this.shiftId
      elemIF.style.display = 'none'
      this.$refs.shiftEndDetailComponent.appendChild(elemIF)
    },
    goback () {
      this.$router.go(-1)
    },
    getData (str) {
      if (str != null && str !== '') {
        return DateUtil.hourMin(str)
      } else {
        return ''
      }
    },
    // マップ弹出场所地图
    map (homeLat, homeLng, name, index, routeType, address) {
      homeLat = parseFloat(homeLat)
      homeLng = parseFloat(homeLng)
      this.$refs.showMapWindow.mapId = 'home'
      // 图标样式
      let vehiclePoint = {
        lat: homeLat,
        lng: homeLng,
        icon: mapDropPin
      }
      var centerPoint = {
        lat: homeLat,
        lng: homeLng
      }
      let addressInfo = ''
      if (index === 'S') {
        addressInfo = '出発地: ' + name
      } else if (index === 'G') {
        addressInfo = '終着地: ' + name
      } else if (routeType === '0') {
        addressInfo = '停留所' + index.substring(1) + ': ' + name
      } else {
        addressInfo = '経由地' + index + ': ' + address
      }
      this.$refs.showMapWindow.mapTitle = addressInfo
      this.$refs.showMapWindow.centerPoint = centerPoint
      this.$refs.showMapWindow.markPosition = vehiclePoint
      this.$refs.showMapWindow.initiGoogleMap()
    },
    getPassengerNameObj (reserveId) {
      for (let reservation of this.shiftInfo.shiftReservationInfos) {
        if (reservation.reserveId === reserveId) {
          return {name: reservation.lastName + ' ' + reservation.firstName, nameKana: reservation.lastNameKana + ' ' + reservation.firstNameKana}
        }
      }
      return null
    },
    getPassengerAddressObj (reserveId) {
      for (let reservation of this.shiftInfo.shiftReservationInfos) {
        if (reservation.reserveId === reserveId) {
          if (this.shiftInfo.shiftFlag === 0) {
            switch (reservation.startPlaceType) {
              case 1:
                return {address: reservation.homeAddress, stationId: '', lat: reservation.homeLat, lng: reservation.homeLng}
              case 2:
                return {address: reservation.startStationAddress, stationId: reservation.startStationId, lat: reservation.startStationLat, lng: reservation.startStationLng}
              default:
                return {address: reservation.startPlaceName, stationId: '', lat: reservation.startPlaceLat, lng: reservation.startPlaceLng}
            }
          } else {
            switch (reservation.arrivePlaceType) {
              case 1:
                return {address: reservation.homeAddress, stationId: '', lat: reservation.homeLat, lng: reservation.homeLng}
              case 2:

                return {address: reservation.arriveStationAddress, stationId: reservation.arriveStationId, lat: reservation.arriveStationLat, lng: reservation.arriveStationLng}
              default:
                return {address: reservation.arrivePlaceName, stationId: reservation.startStationId, lat: reservation.arrivePlaceLat, lng: reservation.arrivePlaceLng}
            }
          }
        }
      }
      return null
    },
    // 判断当前经由地是否停车
    isStop (stationId) {
      // 上车乘客
      let startPassengers = []
      // 下车乘客
      let arrivePassengers = []
      let stopFlag = false
      for (let reservation of this.shiftInfo.shiftReservationInfos) {
        // 获取停留所上车人
        if (reservation.startStationId === stationId) {
          startPassengers.push({reserveId: reservation.reserveId, name: reservation.lastName + reservation.firstName})
          stopFlag = true
        }
        if (reservation.arriveStationId === stationId) {
          arrivePassengers.push({reserveId: reservation.reserveId, name: reservation.lastName + reservation.firstName})
          stopFlag = true
        }
      }
      return {stopFlag: stopFlag, startPassengers: startPassengers, arrivePassengers: arrivePassengers}
    },
    getPassengerName (startPassengers) {
      let name = ''
      if (startPassengers.length > 0) {
        name = '乗車者:' + '&nbsp;&nbsp'
        for (let startPassenger of startPassengers) {
          name += startPassenger.name
          name += '、'
        }
        name = name.substring(0, name.length - 1)
      }
      return name
    },
    // 8桁年月日を表示用に変換する yyyyMMdd 
    getYearWeek (dateStr) {
      if (dateStr == null || dateStr == '') {
        return ''
      }
      return DateUtil.yearWeek(dateStr)
    },
    // 12桁年月日時刻を表示用に変換するyyyyMMddHHmmss 
    getHourMin (dateStr) {
      if (dateStr == null || dateStr == '') {
        return ''
      }
      return dateStr.substr(8, 2) + ':' + dateStr.substr(10, 2)
    },
    operationRecord () {
      this.$router.push({path: '/OperationRecord'})
    }
  },
  mounted () {
    // this.$emit('transShiftID', this.$route.query.shiftId)
    this.$emit('transShiftID', this.shiftId)
  }
}
</script>
<template>
  <div style="height:80%" ref="shiftEndDetailComponent">
    <div class="col-md-12 column header" >
        <div class="col-md-3 column headerleft F1-R-19">
          <input type="button" :value="backName"  @click="goback"/>
        </div>
        <div class="col-md-1 column"></div>
        <div class="col-md-4 column headermiddle F3-M-27">
          便の詳細
        </div>
        <div class="col-md-4 column ">
          <button v-if='rightToBtn&&!shiftMovementFlag' class="common-btn right-btn F2-R-19" @click="goPrintRunningTable">{{rightTopBtnName}}</button>
        </div>
    </div>
    <div class="col-md-12 column tablediv scrollbar slider" style="height:90%; margin-left:0px">
      <table class="table table-bordered window-table">
        <tbody>
          <tr>
            <td width='10%' class="bgc8 F3-R-15 td-key">便名</td>
            <td width='50%' class="td-value F3-M-18" colspan="5">{{shiftInfo1.title}}</td>
          </tr>
          <tr>
            <td class="bgc8 F3-R-15 td-key">便<span> ID</span></td>
            <td class="td-value F3-M-18" colspan="5">{{shiftInfo1.shiftId}}</td>
          </tr>
          <tr v-if="shiftMovementFlag === false">
            <td class="bgc8 F3-R-15 td-key">ルート</td>
            <td class="td-value F3-M-18" colspan="5">{{routeName}}</td>
          </tr>
          <tr>
            <td class="bgc8 F3-R-15 td-key">行き/帰り</td>
            <td class="td-value F3-M-18" colspan="5">
              <div v-if="shiftInfo1.shiftFlag===1">帰り</div>
              <div v-else>行き</div>
            </td>
          </tr>
           <tr>
            <td class=" bgc8 F3-R-15 td-key">地区フィルター</td>
            <td class="td-value F3-M-18" colspan=5>{{shiftInfo1.areaName}}</td>
          </tr>
          <tr>
            <td class="bgc8 F3-R-15 td-key">運行日</td>
            <td class="td-value F3-M-18" colspan="3">{{shiftInfo1.moveShiftTime}}</td>
            <td width='10%' class='bgc8 F3-R-15 td-key '>
              待機時間
            </td>
            <td width='10%' class="td-value F3-M-18 textCenter">
              {{shiftInfo1.waitSumTime}}分
            </td>
          </tr>
          <tr v-for='(shiftPasspoint,key) in shiftPasspoints1' :key="key">
            <td class='bgc8 F3-R-15 td-key'>
              <span v-if="shiftPasspoint.index==='S'">出発地</span>
              <span v-else-if="shiftPasspoint.index==='G'">終着地</span>
              <span v-else-if="shiftPasspoint.routeType==='0'">停留所{{shiftPasspoint.index.substring(1)}}</span>
              <span v-else>経由地{{shiftPasspoint.index}}</span>
            </td>
            <td width='50%' :class=" shiftPasspoint.stopFlag===true && shiftPasspoint.displayFlag === 1? 'td-value F3-M-18' : 'td-value1 F9-M-18'" >
              <span v-if="shiftPasspoint.routeType==='1'" class="spanheight">
                {{shiftPasspoint.address}}&nbsp;&nbsp;&nbsp;
                <span v-html="getPassengerName(shiftPasspoint.startPassengers) "></span>
              </span>
              <span v-else-if="shiftPasspoint.stopFlag===true && shiftPasspoint.displayFlag === 1" class="spanheight">
                {{shiftPasspoint.name}}&nbsp;&nbsp;&nbsp;
                <span v-html="getPassengerName(shiftPasspoint.startPassengers) "></span>
              </span>
              <span v-else class="spanheight">
                <span class="F3-M-18">↓</span>{{shiftPasspoint.name}}&nbsp;&nbsp;&nbsp;
                <span v-html="getPassengerName(shiftPasspoint.startPassengers) "></span>
              </span>
              <a href="#modal-container-staySave"  data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                <button  v-if="mapBtnVisibility" class="mapbtn F2-M-15" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;"
                @click="map(shiftPasspoint.stationLat,shiftPasspoint.stationLng,shiftPasspoint.name,shiftPasspoint.index,shiftPasspoint.routeType,shiftPasspoint.address)">
                  マップ
                </button>
              </a>
            </td>
            <td width='10%'  class='bgc8 F3-R-15 td-key'>
              <span v-if="shiftPasspoint.index==='S'">出発予定時間</span>
              <span v-else>到着予定時間</span>
            </td>
            <td width='10%' :class=" shiftPasspoint.stopFlag===true? 'td-value F3-M-18 textCenter' : 'td-value1 F7-M-18 textCenter'">
              {{getData(shiftPasspoint.estimateTime)}}
            </td>
            <td width='10%' class='bgc8 F3-R-15 td-key '>
              <span v-if="shiftPasspoint.index==='S'">出発時間</span>
              <span v-else>到着時間</span>
            </td>
            <td width='10%' class="td-value F3-M-18 textCenter">
              <span v-if="shiftPasspoint.stopFlag===true && shiftInfo1.coercionStopFlag === 0">
                {{getData(shiftPasspoint.actualTime)}}
              </span>
              <span v-else-if="shiftInfo1.coercionStopFlag === 0">↓</span>
              <span v-else-if="!shiftPasspoint.stopFlag && key<shiftPasspoints1.length-1">
                {{stopWhere(shiftPasspoints1,key)?"↓":getData(shiftPasspoint.actualTime)}}
              </span>
              <span v-else>{{getData(shiftPasspoint.actualTime)}}</span>
            </td>
          </tr>
          <tr>
            <td class="bgc8 F3-R-15 td-key">利用料金</td>
            <td class="td-value F3-M-18" colspan="1">{{shiftInfo1.shiftCost}}円</td>
            <td class="bgc8 F3-R-15 td-key" colspan="1">
              強制終了日時
            </td>
            <td class="td-value F3-M-18" colspan="3">
              {{getYearWeek(shiftInfo1.coercionStopTime)}} {{getHourMin(shiftInfo1.coercionStopTime)}}
            </td>
          </tr>
          <tr>
            <td class=" bgc8 F3-R-15 td-key">フリガナ</td>
            <td class="td-value F3-M-18" colspan=5>{{shiftInfo1.driverNameKana}}</td>
          </tr>
           <tr>
            <td class=" bgc8 F3-R-15 td-key">ドライバー</td>
            <td class="td-value F3-M-18" colspan=5>{{shiftInfo1.driverName}}</td>
          </tr>
          <tr>
            <td class=" bgc8 F3-R-15 td-key">車両</td>
            <td class="td-value F3-M-18" colspan=5>
              {{shiftInfo1.vehicleName}}&nbsp;&nbsp;&nbsp;ID:{{shiftInfo1.displayVehicleId}}&nbsp;&nbsp;&nbsp;定員{{shiftInfo1.passengerNumber}}名
            </td>
          </tr>
          <tr>
            <td class=" bgc8 F3-R-15 td-key">出発メーター</td>
            <td class="shift-col-meter" colspan="5">
              <div class="shift-meter-data">
              {{(shiftInfo1.startDistance!=null)?(shiftInfo1.startDistance).toLocaleString():""}}km
              </div>
              <div class="shift-meter-title">
                到着メーター
              </div>
              <div class="shift-meter-data">
                {{(shiftInfo1.returnDistance!=null)?(shiftInfo1.returnDistance).toLocaleString():""}}km
              </div>
              <div class="shift-meter-title">
                走行距離
              </div>
              <div class="shift-meter-data">
                {{(shiftInfo1.totalDistance!=null)?(shiftInfo1.totalDistance).toLocaleString():""}}km
              </div>
            </td>
            <!-- <td class="td-value F3-M-18" colspan=1>
              {{(shiftInfo1.startDistance).toLocaleString()}}km
            </td>
            <td class=" bgc8 F3-R-15 td-key">帰社メーター</td>
            <td class="td-value F3-M-18" colspan=1>
              {{(shiftInfo1.returnDistance).toLocaleString()}}km
            </td>
            <td class=" bgc8 F3-R-15 td-key">走行距離</td>
            <td class="td-value F3-M-18" colspan=1>
              {{(shiftInfo1.totalDistance).toLocaleString()}}km
            </td> -->
          </tr>
          <tr>
            <td class=" bgc8 F3-R-15 td-key">コメント</td>
            <td class="td-value F3-M-18" colspan=5>
              {{shiftInfo1.comment}}
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 乗客情報 -->
      <table class="table table-bordered window-table">
        <tbody>
          <tr v-for='(item,key) in shiftInfo1.shiftReservationInfos' :key="key">
            <td class="bgc8 F3-R-15 td-key"
              style="min-width: 60px;">
              乗客
            </td>
            <td class="td-value F3-M-18"
              style="min-width: 160px;">
              {{item.lastName}} {{item.firstName}}
            </td>
            <td class="bgc8 F3-R-15 td-key"
              style="min-width: 60px;">
              乗車
            </td>
            <td class="td-value F3-M-18"
              style="min-width: 90px;">
              <span v-if="item.pickupFlag == '0'">なし</span>
              <span v-else-if="item.pickupFlag == '1'">あり</span>
              <span v-else>未確定</span>

            </td>
            <td class="bgc8 F3-R-15 td-key"
              style="min-width: 100px;">
              乗車場所
            </td>
            <td class="td-value F3-M-18">
              <span v-if="item.startPlaceType === 1">{{item.homeAddress}}</span>
              <span v-else>{{item.startStationName}}</span>
            </td>
            <td class="bgc8 F3-R-15 td-key"
              style="min-width: 100px;">
              降車場所
            </td>
            <td class="td-value F3-M-18">
              <span v-if="item.arrivePlaceType === 1">{{item.homeAddress}}</span>
              <span v-else>{{item.arriveStationName}}</span>
            </td>
            <td class="bgc8 F3-R-15 td-key"
              style="min-width: 60px;">
              乗員
            </td>
            <td class="td-value F3-M-18"
              style="min-width: 60px;">
              {{item.passengerNumber}}人
            </td>
            <td class="bgc8 F3-R-15 td-key"
              style="min-width: 100px;">
              利用料金
            </td>
            <td class="td-value F3-M-18"
              style="min-width: 100px;">
              {{item.passengerCost}}円
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-bordered window-table" v-if="shiftInfo1.correctFlag===1">
        <tbody>
          <tr>
            <td width='10%' class="bgc8 F3-R-15 td-key">訂正理由・備考</td>
            <td class="td-value F3-M-18 word-breaker" colspan="5">{{shiftInfo1.correctNote}}</td>
          </tr>
        </tbody>
      </table>
      <table v-if="this.eventId!==null && this.eventId!==''" class="table table-bordered window-table">
          <tbody>
            <tr>
              <td class="bgc3 F2-M-19" colspan="3">イべント項目</td>
            </tr>
            <tr>
              <td class="F3-M-18" rowspan="3" style="width:20%; padding:10px ">
                          <div class="img-bg">
                            <img v-show="eventInfo.eventPhotoUrl" :src="eventInfo.eventPhotoUrl" class="img-style"/>
                            <div v-show="!eventInfo.eventPhotoUrl" class="bgc10 F2-M-18">No Image</div>
                          </div>
              </td>
              <td class=" bgc8 F3-R-15 td-key" width="10%">イベント名</td>
              <td class="td-value F3-M-18 word-breaker">{{eventInfo.eventName}}</td>
            </tr>
            <tr>
              <td class=" bgc8 F3-R-15 td-key" >開催日</td>
              <td class="td-value F3-M-18">{{eventDate}}</td>
            </tr>
            <tr>
              <td class=" bgc8 F3-R-15 td-key" style="line-height:300px; height:300px">開催概要</td>
              <td class="td-value F3-M-18">
                <!-- <div class="ql-container ql-snow"> -->
                <div class="ql-editor" style="width:100%" v-html="eventInfo.eventNote"></div>
                <!-- </div> -->
              </td>
            </tr>
          </tbody>
        </table>
    </div>
    <showMap ref="showMapWindow"></showMap>
    <v-dialog v-show="showPrintDialog" :dialog-option="dialogPrintOption" ref="printDialog"></v-dialog>
  </div>
</template>
<style lang="scss" scoped>
.word-breaker{
  word-break: break-all;
}
//左上返回按钮
.headerleft {
  background: url(../assets/button/back_button.png) no-repeat 10px center;
  // background-size: 5%;
}
.headerleft  input {
  float: left;
  border: none;
  background: none;
  text-align:left;
  text-indent:15%;
  height: 50px;
  line-height: 50px;
  width: 60%;
}
.header{
    vertical-align:middle;
    padding-top: 18px;
    padding-bottom: 18px;
  }
//头部中间
.headermiddle {
  height: 50px;
  line-height: 50px;
  font-size: 24px;
}
.headerright{
  height: 50px;
  line-height: 50px;
  font-size: 24px;
}
//头部右边按钮
.right-btn{
  margin-top:6px;
  margin-bottom: 6px;
  float:right;
  border: none
}
  //表格
.window-table{
  min-width: 1250px;
  font-size: 18px;
  border: 1px solid #959595;
 }
 //边框
.table-bordered>tbody>tr>td{
  border: 1px solid #959595;
}
.td-key{
 vertical-align:middle;
}
//关于值的列的设置（深色）
.td-value{
  padding:9px;
  padding-left: 20px;
  text-align: left;
  vertical-align:middle;
  border: 1px solid #959595;
}
//关于值的列的设置（浅色）
.td-value1{
  padding:9px;
  padding-left: 20px;
  text-align: left;
  vertical-align:middle;
  border: 1px solid #959595;
  color:#bbbbbb;
}
  //统一的地图按钮样式
  .mapbtn{
  height: 30px;
  width: 80px;
  font-size: 18px;
  border: none;
  background: linear-gradient(rgb(167, 167, 165) 50%, rgb(145,146,141) 50%);
  border-radius: 4px;
  float: right;
  margin-right: 0.5%;
  color:black;
}
.tablediv {
  height:100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-right: 1px;
}
.img-bg{
  color: #fff;
  // background:grey;
  width:100%;
  height: 200px;
  line-height: 200px;
  // font-size: 20px;s
  // text-align: center;
  // margin-left: auto;
  // margin-right: auto;
}
.img-style{
  height: 100%;
  width: 100%;
}
.ql-container{
  border: none
}
.ql-editor {
  height: 300px;
  padding:0;
  font-size: 1.6vw;
  word-break:break-all
}
.spanheight{
  height:30px;
  display: inline-block;
  line-height: 30px;
}
.textCenter{
  text-align: center;
}
.shift-col-meter{
  display: flex;
  border: none!important;
  padding: 0;
  width: 180%;
  height: 47px;
  line-height: 47px;
  font-size: 18px;
  text-align: center;
  
  .shift-meter-data{
    border-right: 1px solid #959595;
    width: 10%;
  }
  .shift-meter-title{
    font-size: 15px;
    border-right: 1px solid #959595;
    width: 10%;
    background-color: #DAE1E6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shiftEndDetailComponent.vue